<template>
    <!-- <img src="./assets/logo.png"> -->
    <router-view/>
</template>

<script>
export default {
  name: 'App'
}
</script>


<style>
    @import "../static/css/main.css";
    @import "../static/css/theme-green/color-green.css"; 
    /* @import '../static/css/theme-green/index.css'; */
</style>



// WEBPACK FOOTER //
// src/App.vue